import { z } from 'zod';
export const kullaniciDurumu = z.enum(['AKTIF', 'PASIF', 'ENGELLI']);
export const dilKodu = z.enum(['tr', 'en']);
export const kullanici = z.object({
    id: z.string(),
    eposta: z.string().email(),
    adSoyad: z.string(),
    telefon: z.string().nullable().optional(),
    durum: kullaniciDurumu,
    dilTercihi: dilKodu,
    roller: z.array(z.string()).default([]),
    izinler: z.array(z.string()).default([]),
    olusturmaTarihi: z.string().datetime(),
});
export const kullaniciOlusturIstegi = z.object({
    eposta: z.string().email(),
    parola: z.string().min(8).max(128),
    adSoyad: z.string().trim().min(2).max(120),
    telefon: z.string().optional(),
    rolAdlari: z.array(z.string()).default([]),
    dilTercihi: dilKodu.default('tr'),
});
export const kullaniciGuncelleIstegi = z.object({
    adSoyad: z.string().trim().min(2).max(120).optional(),
    telefon: z.string().nullable().optional(),
    durum: kullaniciDurumu.optional(),
    dilTercihi: dilKodu.optional(),
    rolAdlari: z.array(z.string()).optional(),
});
export const rol = z.object({
    id: z.string(),
    ad: z.string(),
    aciklama: z.string().nullable().optional(),
    sistemRolu: z.boolean(),
    izinler: z.array(z.string()),
});
//# sourceMappingURL=kullanici.js.map